var map = {
	"./modal_mixins.js": 66,
	"./modal_mixins.js.es6": 66,
	"./sortable_default_options.js": 67,
	"./sortable_default_options.js.es6": 67
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;


//////////////////
// WEBPACK FOOTER
// ./boards/mixins ^\.\/.*\.(js|es6)$
// module id = 160
// module chunks = 1